import { render, staticRenderFns } from "./helpMobile.vue?vue&type=template&id=0ab0a578&scoped=true"
import script from "./helpMobile.vue?vue&type=script&lang=js"
export * from "./helpMobile.vue?vue&type=script&lang=js"
import style0 from "./helpMobile.vue?vue&type=style&index=0&id=0ab0a578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0a578",
  null
  
)

export default component.exports